import { Observable } from 'rxjs';

import { Inject, LOCALE_ID, NgModule } from '@angular/core';
import { TranslateCompiler, TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';

import { LocalesEnum } from './constants/locales.enum';
import { environment } from '~env/environment';

export class TranslationLoader implements TranslateLoader {
  constructor(
    private readonly http: HttpClient,
  ) {
  }

  getTranslation(lang: string): Observable<any> {
    const staticUrl = () => environment.appStaticUrl();
    const pipelineId = environment.pipelineId();
    return this.http.get(`${staticUrl()}/static/assets/i18n/${lang}.json?v=${pipelineId}`);
  }
}

@NgModule({
  imports: [
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: TranslationLoader,
        deps: [HttpClient],
      },
      compiler: {
        provide: TranslateCompiler,
        useClass: TranslateMessageFormatCompiler,
      },
    })
  ],
  exports: [TranslateModule],
})
export class L10nModule {
  constructor(
    private readonly translate: TranslateService,
    @Inject(LOCALE_ID) protected localeId: string,
  ) {
    this.translate.addLangs([LocalesEnum.en, LocalesEnum.de, LocalesEnum.es]);
    this.localeId
      ? this.translate.use(this.localeId)
      : this.translate.setDefaultLang(LocalesEnum.de);
  }
}
